import { CustomUseQueryOptions } from '../types';
import { hasNonEmptyProp } from '@/libs/common/utils';
import { ApiInstance, BaseFetchParams, Section } from '@/libs/sdk/api';
import { useQuery } from '@tanstack/react-query';

export const useSections = (api: ApiInstance, searchParams: BaseFetchParams, options?: CustomUseQueryOptions<Section[]>) => {
  const { queryKey, enabled = true, ...rest } = options || {};
  return useQuery({
    ...rest,
    enabled: enabled && hasNonEmptyProp(searchParams, ['baseTokenAddress']),
    queryKey: [queryKey, 'Sections', searchParams],
    queryFn: async ({ signal }) => {
      const { data } = await api.market.getSections(searchParams, { signal });
      return data.sections;
    },
  });
};
